export default __webpack_public_path__ + "static/media/obsluga.f59bafd6.svg";